if (typeof __LOG_INFO__ === 'undefined') { var __LOG_INFO__ = false; }
if (typeof __LOG_WARN__ === 'undefined') { var __LOG_WARN__ = false; }
if (typeof __LOG_ERROR__ === 'undefined') { var __LOG_ERROR__ = true; }
if (typeof AppLog === 'undefined') {
    var AppLog = {
        info: console.info || console.log,
        warn: console.warn || console.log,
        error: console.error || console.log,
        log: console.log
    };
}

if (__LOG_INFO__) AppLog.info('1. Storage Management script loading...');
// Expiration time constants (in minutes)
const CACHE_EXPIRATION = {
    ONE_HOUR: 60,
    ONE_DAY: 24 * 60,           // 1440 minutes
    ONE_WEEK: 7 * 24 * 60,       // 10080 minutes
    ONE_MONTH: 30 * 24 * 60,     // 43200 minutes
    ONE_YEAR: 365 * 24 * 60,     // 525600 minutes - for user preferences
    PERSISTENT: 10 * 365 * 24 * 60  // ~10 years - effectively permanent
};

// Check current storage usage
function checkStorageUsage() {
    let total = 0;
    for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
            total += ((localStorage[key].length + key.length) * 2); // Rough byte size
        }
    }
    if (__LOG_INFO__) AppLog.info('Total size in bytes:', total);
    if (__LOG_INFO__) AppLog.info('Total size in MB:', total / (1024 * 1024));
}

// Set an item in localStorage with a custom expiration time (in minutes)
function setCacheItem(key, value, expirationInMinutes) {
    const now = Date.now();
    const expiry = now + expirationInMinutes * 60 * 1000; // Convert to milliseconds
    const item = {
        value: value,
        expiry: expiry,
    };
    try {
        localStorage.setItem(key, JSON.stringify(item));
    } catch (e) {
        if (e.name === 'QuotaExceededError') {
            if (__LOG_WARN__) AppLog.warn('Storage quota exceeded, cleaning up stale items first');
            cleanExpiredItems(); // Cleanup and retry
            localStorage.setItem(key, JSON.stringify(item));
        } else {
            throw e;
        }
    }
}

// Get an item from localStorage, checking its expiry (protected keys bypass expiry)
function getCacheItem(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = Date.now();

    // If the key is protected, return the value regardless of expiry
    const protectedKeys = JSON.parse(localStorage.getItem('protectedKeys') || '[]');
    if (protectedKeys.includes(key) || key === 'debug' || key === 'lastCleanup' || key === 'protectedKeys') {
        return item.value || item; // Return raw value if no expiry wrapper (e.g., debug)
    }

    // Check expiry for non-protected keys
    if (now > item.expiry) {
        localStorage.removeItem(key); // Remove expired item
        return null;
    }
    return item.value;
}

// Remove all expired items from localStorage, respecting protected keys
function cleanExpiredItems() {
    const now = Date.now();
    const protectedKeys = JSON.parse(localStorage.getItem('protectedKeys') || '[]');

    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (!key) continue;

        // Skip protected keys and management keys
        if (key === 'debug' || key === 'lastCleanup' || key === 'protectedKeys' || protectedKeys.includes(key)) {
            continue;
        }

        const itemStr = localStorage.getItem(key);
        try {
            const item = JSON.parse(itemStr);
            if (item && item.expiry && now > item.expiry) {
                localStorage.removeItem(key);
            }
        } catch (e) {
            if (__LOG_WARN__) AppLog.warn(`Skipping invalid cache entry for key: ${key}`, e);
        }
    }

    // Update lastCleanup timestamp (no expiry wrapper)
    localStorage.setItem('lastCleanup', JSON.stringify(now));
    if (__LOG_INFO__) AppLog.info('Expired items cleaned up at', new Date().toISOString());
    checkStorageUsage();
}

// New function to clean non-conforming items (no expiry attribute, not protected)
function cleanNonConformingItems() {
    const protectedKeys = JSON.parse(localStorage.getItem('protectedKeys') || '[]');
    let removedCount = 0;

    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (!key) continue;

        // Skip protected keys and management keys
        if (key === 'debug' || key === 'lastCleanup' || key === 'protectedKeys' || protectedKeys.includes(key)) {
            continue;
        }

        const itemStr = localStorage.getItem(key);
        try {
            const item = JSON.parse(itemStr);
            // If the item lacks an expiry attribute, remove it
            if (!item || typeof item !== 'object' || !('expiry' in item)) {
                localStorage.removeItem(key);
                removedCount++;
            }
        } catch (e) {
            // If parsing fails (e.g., raw string), remove it
            if (__LOG_WARN__) AppLog.warn(`Removing invalid or non-JSON entry for key: ${key}`, e);
            localStorage.removeItem(key);
            removedCount++;
        }
    }

    if (removedCount > 0) {
        if (__LOG_INFO__) AppLog.info(`Cleaned up ${removedCount} non-conforming items from localStorage at`, new Date().toISOString());
    } else {
        if (__LOG_INFO__) AppLog.info('No non-conforming items found in localStorage');
    }
    checkStorageUsage();
}

// Run cleanup every X minutes
function startCacheCleanup(intervalInMinutes) {
    const intervalMs = intervalInMinutes * 60 * 1000;
    cleanExpiredItems(); // Run immediately
    setInterval(cleanExpiredItems, intervalMs);
}

// Initialize management keys if not present and clean non-conforming items
function initializeStorageState() {
    if (!localStorage.getItem('lastCleanup')) {
        localStorage.setItem('lastCleanup', JSON.stringify(Date.now()));
    }
    if (!localStorage.getItem('protectedKeys')) {
        localStorage.setItem('protectedKeys', JSON.stringify(['auth_session', 'auth_session_mirror'])); // Default protection for auth sessions
    }
    // Clean non-conforming items on initialization
    cleanNonConformingItems();
}

// Helper to add a key to the protected list
function protectKey(key) {
    const protectedKeys = JSON.parse(localStorage.getItem('protectedKeys') || '[]');
    if (!protectedKeys.includes(key) && key !== 'debug' && key !== 'lastCleanup' && key !== 'protectedKeys') {
        protectedKeys.push(key);
        localStorage.setItem('protectedKeys', JSON.stringify(protectedKeys));
    }
}

// Example usage
initializeStorageState(); // Set up initial state and clean non-conforming items
startCacheCleanup(60); // Run cleanup every 60 minutes

// Expose API to global window so non-module scripts (and other bundles) can use it
(function exposeStorageAPIToWindow(){
  try {
    if (typeof window !== 'undefined') {
      if (!window.getCacheItem) window.getCacheItem = getCacheItem;
      if (!window.setCacheItem) window.setCacheItem = setCacheItem;
      if (!window.cleanExpiredItems) window.cleanExpiredItems = cleanExpiredItems;
      if (!window.cleanNonConformingItems) window.cleanNonConformingItems = cleanNonConformingItems;
      if (!window.startCacheCleanup) window.startCacheCleanup = startCacheCleanup;
      if (!window.protectKey) window.protectKey = protectKey;
      if (!window.CACHE_EXPIRATION) window.CACHE_EXPIRATION = CACHE_EXPIRATION;
    }
  } catch (_) { /* no-op */ }
})();